import React from "react"
import OperationalDashboard from "./Operational";

const Dashboard = (props) => {

  document.title = "Dashboard | NeoApp - Sistema de Gestão";

  return (
    <React.Fragment>
      <OperationalDashboard />
    </React.Fragment>
  )
}

export default Dashboard;